import FeedbackFilter from "./feedback-filter";
import FeedbackForm from "./feedback-form";
export default class PageModule {
	constructor() {
		this.initFeedbackFilter();
		this.initFeedbackForm();
	}

	initFeedbackFilter() {
		this.feedbackFilter = new FeedbackFilter();
	}

	initFeedbackForm() {
		const form = new FeedbackForm();
	}
}